import store from '../store/store'
import cookie from 'vue-cookies'

export async function reset({ next, to }) {
  store
    .dispatch('auth/check_user', to.query)
    .then(() => {
      return next()
    })
    .catch(() => {
      return next('/')
    })
}

export function logged({ next, store }) {
  const loggedIn = JSON.parse(localStorage.getItem('header'))
  if (loggedIn) {
    store.commit('auth/set_loggedIn', true);
    store.commit('auth/set_workflow', JSON.parse(localStorage.getItem('workflow')))
    store.commit('auth/set_user', JSON.parse(localStorage.getItem('user')))
    return next()
  } else {
    return next('/')
  }
}

export function loggedIPS({ next }) {
  const loggedIn = cookie.get('auth-token')
  if (loggedIn) {
    return next()
  } else {
    return next('/')
  }
}

export function notlogged({ next, store }) {
  const loggedIn = JSON.parse(localStorage.getItem('header'))
  if (loggedIn) {
    localStorage.clear()
    sessionStorage.clear()
    window.location.reload()
    return next()
  } else {
    return next()
  }
}

export function signed({ next, store }) {
  const signed = store.state.data.signed
  if (signed) {
    return next()
  } else {
    return next('/')
  }
}

export function revoked({ next, store }) {
  const revoked = store.state.data.revoked
  if (revoked) {
    return next()
  } else {
    return next('/')
  }
}

export function isAdmin({ next, store }) {
  const user = JSON.parse(localStorage.getItem('user'))
  if (user) {
    store.commit('auth/set_user', JSON.parse(localStorage.getItem('user')))
    store.commit('auth/set_loggedIn', true)
    if (
      user.account_role !== 'organization_admin' &&
      user.account_role !== 'admin'
    ) {
      return next('/')
    } else {
      return next()
    }
  } else {
    return next('/adminLogin')
  }
}
